
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Analytics from "./utils/analytics";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Initialize Analytics
Analytics.init();

// Chart.js imports and registration
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const queryClient = new QueryClient(); // Create QueryClient instance

ReactDOM.createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
